import styled from 'styled-components';
import {
  compose,
  space,
  SpaceProps,
  layout,
  LayoutProps,
  color,
  ColorProps,
  typography,
  TypographyProps,
  shadow,
  ShadowProps,
  position,
  PositionProps,
  border,
  BorderProps,
  background,
  BackgroundProps,
  grid,
  GridProps,
  flexbox,
  FlexboxProps
} from 'styled-system';

/**
 * Types for styled-system props.
 */
type SystemProps = SpaceProps &
  ColorProps &
  LayoutProps &
  TypographyProps &
  ShadowProps &
  PositionProps &
  BorderProps &
  BackgroundProps &
  GridProps &
  FlexboxProps;

export interface IBoxProps
  extends SystemProps,
    Omit<React.HTMLProps<HTMLElement>, keyof SystemProps>,
    React.AriaAttributes {}

/**
 * Extendable Styled Box
 * The idea behind this styled box is to expose the design system in a composable way
 * This Box can be rendered as any HTML element by using the styled-component built-in `as` prop
 * https://www.styled-components.com/docs/api#as-polymorphic-prop.
 */

/**
 * Media query is used to target IE browsers to fix text overflow issues within box components
 */
const Box = styled.div<IBoxProps>`
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    word-wrap: break-word;
  }
  ${compose(
    space,
    layout,
    color,
    typography,
    shadow,
    position,
    border,
    background,
    grid,
    flexbox
  )}
`;

Box.displayName = 'Box';

export default Box;
